import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import relevantIcon from 'src/public/img/undraw-studying-s-3-l-7.svg';

import { StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';
import { SimpleSurveyStep } from 'src/modules/programs/surveys/stepComponents/SimpleSurveyStep';

import { CBTProgramWeekFourSurvey } from '../models/weekFour';

interface Props extends StepButtonsProps, WithTranslation {
    programId: ProgramEnum;
}

export const HowDidTrackingYourEmotionsGoStep = withTranslation('cbt')((props: Props) => (
    <SimpleSurveyStep
        {...props}
        programId={props.programId}
        surveyId={CBTProgramWeekFourSurvey.HowDidTrackingYourEmotionsGo}
        heading={
            <>
                <S.StepHeading>
                    {props.t('week-4.how-did-tracking-your-emotions-go.title')}
                </S.StepHeading>
                <S.StepDescription small>
                    {props.t('week-4.how-did-tracking-your-emotions-go.description')}
                </S.StepDescription>
            </>
        }
        modalContent={
            <>
                <S.ModalIcon iconUrl={relevantIcon} />
                <S.ModalTitle>
                    {props.t('week-4.how-did-tracking-your-emotions-go.modal.title')}
                </S.ModalTitle>
                <S.ModalText>
                    {props.t('week-4.how-did-tracking-your-emotions-go.modal.text')}
                </S.ModalText>
            </>
        }
        showQuestionsIndexes
    />
));
